/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function ($) {

  $('.header-menu-button').click(function() {
    $(this).toggleClass('active');
    $('header .header__action').slideToggle();
  });

  $('.chatroom__header--minimize').click(function (e) {
    e.preventDefault()
    $('.section__wrap').addClass('minimize-chatroom')
  })

  $('.chatroom__open').click(function (e) {
    e.preventDefault()
    $('.section__wrap').removeClass('minimize-chatroom')
  })

  $('#open-message').click(function (e) {
    e.preventDefault()
    $('.section__chatroom').addClass('active')
    $('.section__video--info').hide()
  })

  $('#close-message').click(function (e) {
    e.preventDefault()
    $('.section__chatroom').removeClass('active')
    $('.section__video--info').show()
  })

  var shareUrl = window.location.href
  jQuery('#share-facebook').click(function (e) {
    e.preventDefault()
    FB.ui(
      {
        display: 'popup',
        method: 'share',
        href: shareUrl
      },
      function (response) {
        console.log(response)
      }
    )
  })

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  const devices = getMobileOperatingSystem();
  /*let downloadBtn = $('.header__btn--download');
  let downloadBtn2 = $('.modal-download-app');
  if (devices === 'Android') {
    if (downloadBtn.length) {
      downloadBtn.attr('data-toggle', '');
      downloadBtn.attr("target","_blank");
      downloadBtn2.attr('data-toggle', '');
      downloadBtn2.attr("target","_blank");
      downloadBtn.attr("href", "https://bit.ly/vuasanco-apk");
      downloadBtn2.attr("href", "https://bit.ly/vuasanco-apk");
    }
  }

  if (devices === 'iOS') {
    if (downloadBtn.length) {
      downloadBtn.attr('data-toggle', '');
      downloadBtn.attr("target","_blank");
      downloadBtn2.attr('data-toggle', '');
      downloadBtn2.attr("target","_blank");
      downloadBtn.attr("href", "https://bit.ly/vuasanco-apk");
      downloadBtn2.attr("href", "https://bit.ly/vuasanco-apk");
    }
  }*/

  $('.live-match .live-match-title').click(function() {
    $('.live-match-list').slideToggle();
  });

  $('.m_catfish_close').click(function() {
     $('#m_catfish').hide();
     $('footer.footer').addClass('no-ads');
  });
  setTimeout(function() {
    $('#modal-comments').modal('show');
  }, 2000)

  // Slick Slider Hot Match
  $('.hotmatch__box').slick({
    slidesToShow: 3,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 772,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Slick Slider Odds
  $('.odds-mobile__talent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    infinite: false
  });

})
